module.exports = __webpack_public_path__ + "static/media/sentence-scramble.8f9b7680.png";